import React, {Suspense} from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import Loader from "../shared/components/loader";
import Navbar from "../components/navbar";
import ConfirmationDialog from "../shared/components/confirmation-dialog";
import Home from "../components/home";
import Blogs from "../components/blogs";
import BlogEditorPage from "../components/blog-editor/BlogEditorPage";
import Innovation from "../components/innovation";
import Users from "../components/users";
import Authors from "../components/authors";


const MainLayout = () => {


    return (
        <div className={"h-100pe bg-gray"}>
            <Suspense fallback={<Loader load={true}/>}>
                <Navbar/>
                <ConfirmationDialog/>

            </Suspense>
            <div className={"list-view"}>
                <Suspense fallback={<Loader load={true}/>}>
                <Switch>
                    <Route path="/home" component={Home}/>
                    <Route path="/blogs/new" component={BlogEditorPage}/>
                    <Route path="/blogs/edit/:id" component={BlogEditorPage}/>
                    <Route path="/blogs" component={Blogs}/>
                    <Route path="/innovation" component={Innovation}/>
                    <Route path="/users" component={Users}/>
                    <Route path="/authors" component={Authors}/>
                    <Redirect exact from='/' to='/home'/>
                </Switch>
            </Suspense>
            </div>
        </div>

    );
};

export default MainLayout;
